module.exports = __webpack_public_path__ + "static/media/logo.20823674.png";